/**
 * @desc 红人领用管理-详情
 */
const URL = "/rantion-kol";
import http, { updateResponse } from "@/http";
export type Response = defs.kol.ResponseDto<defs.kol.UseCelebrityResponseDto>;
export function request(lyno: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/kol/useCelebrity/details/${lyno}`, {
      method: "GET",

      ...options,
    }),
  );
}
